/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Provides mapping of password requirements that have/haven't been met.
 *
 * The special-character class accepts characters commonly produced by
 * browser/OS password managers (Chrome, Safari, 1Password, Bitwarden),
 * notably the hyphen which Chrome's built-in generator emits regularly.
 * Kept in sync with the backend rule in
 * composable-cavenders-base/.../helpers/passwordValidationHelper.js.
 *
 * @param {string} value - The password to validate
 * @returns {Object} - True/false for each password validation rule
 */
export const validatePassword = (value) => {
    return {
        hasMinChars: value && value.length >= 8 ? true : false,
        hasUppercase: value && /[A-Z]/.test(value) ? true : false,
        hasLowercase: value && /[a-z]/.test(value) ? true : false,
        hasNumber: value && /\d/.test(value) ? true : false,
        hasSpecialChar: value && /[!@#$%^&*()_\-+=.,?:;{}|<>"]/.test(value) ? true : false
    }
}
